import {
  AbstractFormField,
  Bool,
  Date,
  DateTime,
  Number,
  String,
  StringEnum,
  StringEnumRef,
  CheckboxAssociationTwoColumns,
  StringEnumRefIndex,
  Tiles,
  DateTimeSelect,
  DateTimeTiles,
  CheckboxAssociation,
  RadioRefSelect,
  TilesWithSelect,
  SupplementaryInsuranceForm,
  DateInputs,
  SupplementaryInsuranceSelect,
  SupplementaryInsuranceCombinationForm,
  SupplementaryInsuranceCheck,
  BoolNegation,
  ValueNamesWithSelect,
  DateTimeInputs,
  RadioSelect,
  Radios,
  CheckboxWithLabel,
} from './index'

import isMobile from 'is-mobile'

import { EmptyComponent } from '../index'

import EngineCapacityInput from './EngineCapacity'
import ManufacturerSelect from './Manufacturer'
import ModelSelect from './Model'

export default {
  default: AbstractFormField,
  empty: EmptyComponent,
  'string-enum': StringEnum,
  'string-enum-ref': StringEnumRef,
  'string-enum-ref-index': StringEnumRefIndex,
  'int-enum': StringEnum,
  'int-enum-ref': StringEnumRef,
  int: Number,
  float: Number,
  string: String,
  date: Date,
  bool: Bool,
  radios: Radios,
  boolNegation: BoolNegation,
  datetime: DateTime,
  tiles: Tiles,
  tilesWithoutHelp: Tiles,
  dateTimeSelect: DateTimeSelect,
  dateTimeTiles: DateTimeTiles,
  dateInputs: DateInputs,
  dateTimeInputs: DateTimeInputs,
  checkboxAssociation: CheckboxAssociation,
  checkboxAssociationTwoColumns: CheckboxAssociationTwoColumns,
  supplementaryInsuranceForm: SupplementaryInsuranceForm,
  supplementaryInsuranceSelect: SupplementaryInsuranceSelect,
  supplementaryInsuranceCheck: SupplementaryInsuranceCheck,
  radioSelect: RadioSelect,
  radioRefSelect: RadioRefSelect,
  supplementaryInsuranceCombinationForm: SupplementaryInsuranceCombinationForm,
  tilesWithSelect: TilesWithSelect,
  valueNamesWithSelect: ValueNamesWithSelect,
  checkboxWithLabel: CheckboxWithLabel,
  'engine-capacity': EngineCapacityInput,
  manufacturer: ManufacturerSelect,
  model: ModelSelect,
}

export const fieldsClasses = {
  default: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  'string-enum': 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  'string-enum-ref': 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  'string-enum-ref-index': 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  'int-enum': 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  'int-enum-ref': 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  int: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  float: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  string: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  date: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 pr-sm-0',
  bool: 'col-12 col-sm-5 offset-sm-4 mb-1 mt-1',
  boolNegation: 'col-12 col-sm-5 offset-sm-4 mb-1 mt-1',
  datetime: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 pr-sm-0',
  tiles: 'col-12 col-sm-10 order-3 order-sm-0 mt-2',
  "tiles-disabled": 'col-12 col-sm-5 order-3 order-sm-0 mt-2',
  tilesWithoutHelp: 'col-12 order-3 order-sm-0 mt-2 pr-0',
  dateTimeSelect: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 pr-sm-0',
  dateTimeTiles: 'col-10 col-sm-9 order-2 order-sm-0 mt-2',
  dateInputs: 'col-12 col-sm-5 order-3 order-sm-0',
  dateTimeInputs: 'col-12 col-sm-7 order-3 order-sm-0 my-2',
  checkboxAssociation: 'col-12 col-sm-7 order-3 order-sm-0 mt-2',
  checkboxAssociationTwoColumns: 'w-100',
  supplementaryInsuranceForm: '',
  supplementaryInsuranceCombinationForm: '',
  supplementaryInsuranceSelect: 'row w-100',
  radioSelect: 'col-12 col-sm-6 order-3 order-sm-0 mt-2 pr-sm-0',
  radioRefSelect: 'col-12 order-0 order-sm-0',
  tilesWithSelect: 'col-12 col-sm-7 order-3 order-sm-0 mt-2',
  valueNamesWithSelect: 'col-12 col-sm-5 order-3 order-sm-0 pr-sm-0',
  radios: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  checkboxWithLabel: 'col-10 col-sm-4 order-0 order-sm-0',
  'engine-capacity': 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  manufacturer: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  model: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
  acquisitionCppMiniApp: 'col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0',
}

export const labelClasses = {
  default: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  'string-enum': 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  'string-enum-ref': 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  'string-enum-ref-index': 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  'int-enum': 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  'int-enum-ref': 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  int: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  float: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  string: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  date: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  bool: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  boolNegation: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  datetime: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  tiles: 'col-10 col-sm-2 order-0 order-sm-0 text-sm-right',
  "tiles-disabled": 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  tilesWithoutHelp: '',
  dateTimeSelect: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  dateTimeTiles: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  dateInputs: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  dateTimeInputs: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  checkboxAssociation: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  checkboxAssociationTwoColumns: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  supplementaryInsuranceForm: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  supplementaryInsuranceCombinationForm: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  supplementaryInsuranceSelect: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  radioSelect: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  radioRefSelect: 'col-10 col-sm-1 order-0 order-sm-0 text-sm-right',
  tilesWithSelect: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  valueNamesWithSelect: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  radios: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  checkboxWithLabel: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  'engine-capacity': 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  manufacturer: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  model: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
  acquisitionCppMiniApp: 'col-10 col-sm-4 order-0 order-sm-0 text-sm-right',
}

const alignHelpClass = isMobile() ? 'text-right' : 'text-left'

export const helpClasses = {
  default: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  'string-enum': `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  'string-enum-ref': `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  'string-enum-ref-index': `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  'int-enum': `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  'int-enum-ref': `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  int: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  float: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  string: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  date: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  bool: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  boolNegation: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  datetime: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  tiles: `col-2 col-sm-1 order-0 order-sm-0 ${alignHelpClass}`,
  tilesWithoutHelp: '',
  dateTimeSelect: `col-2 col-sm-1 order-0 order-sm-0 ${alignHelpClass}`,
  dateTimeTiles: `col-2 col-sm-2 order-3 order-sm-0 ${alignHelpClass}`,
  dateInputs: 'col-10 col-sm-1 order-0 order-sm-0 text-sm-left',
  dateTimeInputs: 'col-10 col-sm-1 order-0 order-sm-0 text-sm-left',
  checkboxAssociation: `col-2 col-sm-1 order-0 order-sm-0 ${alignHelpClass}`,
  checkboxAssociationTwoColumns: 'd-none',
  supplementaryInsuranceForm: '',
  supplementaryInsuranceCombinationForm: '',
  supplementaryInsuranceSelect: 'row w-100',
  radioSelect: `col-2 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  radioRefSelect: 'd-none',
  tilesWithSelect: `col-2 col-sm-1 order-0 order-sm-0 ${alignHelpClass}`,
  valueNamesWithSelect: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  radios: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  checkboxWithLabel: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  'engine-capacity': `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  manufacturer: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  model: `col-1 col-sm-2 order-0 order-sm-0 ${alignHelpClass}`,
  acquisitionCppMiniApp: '',
}

export const formGroupClasses = {
  'int-enum': 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  'int-enum-ref': 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  'string-enum': 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  'string-enum-ref': 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  'string-enum-ref-index': 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  bool: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  boolNegation: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  date: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  dateInputs: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  datetime: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  default: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  float: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  int: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  radios: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  string: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  valueNamesWithSelect: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  'engine-capacity': 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  manufacturer: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  model: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
  acquisitionCppMiniApp: 'form-group d-flex flex-row flex-wrap flex-sm-row align-items-center',
}
